import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { LayoutService } from "src/app/services/layout.service";

export const mobileBlockGuard: CanActivateFn = () => {
  const layoutService = inject(LayoutService);
  return !layoutService.inMobile; 
};
